import React from "react";
import { Helmet } from "react-helmet";
import NavBar from "../Components/NavBar/NavBar";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../Components/Footer/Footer";

const services = [
  {
    title: "IT Consulting and Architecture Services",
    description:
      "Expert IT consulting and architecture for transformation, analytics, sustainability, mergers, and embracing future-ready digital technologies seamlessly.",
    link: "/it-consulting-architecture",
  },
  {
    title: "Custom Software Design and Development",
    description:
      "We deliver tailored software solutions that transform operations, improve portfolios, and enhance business outcomes through innovation and expertise.",
    link: "/custom-software-development",
  },
  {
    title: "Enterprise Cloud Migration Support Services",
    description:
      "Seamlessly migrate apps and databases to the cloud with our proven planning, execution, and post-migration support for flexibility.",
    link: "/cloud-migration",
  },
  {
    title: "On-Demand Skilled IT Staffing Solutions",
    description:
      "We bridge IT talent gaps with skilled professionals in development, testing, management, infrastructure, and network services globally.",
    link: "/staffing-solutions",
  },
  {
    title: "Mobile App Design and Development",
    description:
      "Custom mobile app solutions empowering clients to accelerate digital journeys and engage users across Android and iOS platforms efficiently.",
    link: "/mobileapp-development",
  },
  {
    title: "Reliable Application Maintenance and Support",
    description:
      "Comprehensive AMS with dedicated, shared, and offshore models supporting global clients in maintaining applications effectively and efficiently.",
    link: "/application-maintenance-support",
  },
  {
    title: "Project Management Office (PMO) Services",
    description:
      "Our PMO services establish project control, resource management, and standard methodologies for successful project delivery and client alignment.",
    link: "/pmo-services",
  },
  {
    title: "Complete SAP Enterprise Support Services",
    description:
      "End-to-end SAP support services including FM, SD, MM, ABAP, testing, security, and third-party integration for smooth operations.",
    link: "/sap-support",
  },
];

const HomePage = () => {
  return (
    <div>
      <Helmet>
        <title>Dhanam Information System</title>
      </Helmet>
      <NavBar />
      <>
        <div className="main-banner position-relative text-center text-white py-5">
          <div className="container position-relative z-1">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <h1 className="banner-title mb-4">
                Unlock AI-Powered                  <span> Solutions for the Tech Industry</span>
                </h1>
                <p className="lead banner-description mb-4">
                Merging human insight with AI innovation to create solutions that evolve, adapt, and drive progress forward.
                </p>
                <ul className="list-unstyled checklist d-flex justify-content-center gap-4 mb-4">
                  <li>50+ Worldwide Projects</li>
                  <li>5+ Countries</li>
                </ul>
                <a href="../contact-us" className="btn btn-primary px-4 py-2">
                  Contact Us
                </a>
              </div>
            </div>
          </div>

          {/* Background SVG */}
          <svg
            className="bg-ellipse position-absolute top-0 start-0 w-100 h-100"
            viewBox="0 0 1140 820"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="60"
              width="1"
              height="820"
              fill="white"
              fillOpacity="0.1"
            />
            <rect
              x="256"
              width="1"
              height="820"
              fill="white"
              fillOpacity="0.08"
            />
            <rect
              x="452"
              width="1"
              height="820"
              fill="white"
              fillOpacity="0.06"
            />
            <rect
              x="648"
              width="1"
              height="820"
              fill="white"
              fillOpacity="0.06"
            />
            <rect
              x="844"
              width="1"
              height="820"
              fill="white"
              fillOpacity="0.08"
            />
            <rect
              x="1040"
              width="1"
              height="820"
              fill="white"
              fillOpacity="0.1"
            />
            <circle
              cx="60"
              cy="180"
              r="18"
              fill="#36C5F0"
              stroke="#ffffff"
              strokeWidth="4"
            />
            <circle
              cx="1040"
              cy="410"
              r="9"
              fill="#FFBB0C"
              stroke="#ffffff"
              strokeWidth="2"
            />
            <circle cx="60" cy="410" r="10" fill="#FFBB0C" />
            <circle cx="1040" cy="180" r="20" fill="#FFBB0C" />
          </svg>

          <style jsx>{`
            .main-banner {
              background-color: rgb(11, 22, 63); /* Updated background */
              overflow: hidden;
              position: relative;
              padding-top: 80px;
              padding-bottom: 120px;
            }

            .banner-title {
              font-weight: 600;
              font-size: 2.5rem;
            }

            .banner-title span {
              font-weight: 400;
              color: #ffffff;
            }

            .banner-description {
              font-size: 1.25rem;
            }

            .checklist li {
              position: relative;
              padding-left: 25px;
            }

            .checklist li::before {
              content: "✓";
              position: absolute;
              left: 0;
              color: #ffbb0c;
            }

            .bg-ellipse {
              z-index: 0;
              pointer-events: none;
            }

            @media (min-width: 992px) {
              .banner-title {
                font-size: 4rem;
              }
              .banner-description {
                font-size: 1.5rem;
              }
            }
          `}</style>
        </div>
        <Container></Container>

        <Container>
          <div className="py-5">
            <Row className="pt-3">
              <Col className="d-flex justify-content-center align-items-center">
                <div>
                  {" "}
                  <h1 className="fw-bold" style={{ fontSize: "50px" }}>
                    Turn strategy into remarkable outcomes
                  </h1>
                  <h5>
                    Evolve your enterprise strategy and planning with a
                    collection of apps that help you deliver better outcomes
                    across your business.
                  </h5>
                </div>
              </Col>
              <Col>
                <img
                  src="https://dam-cdn.atl.orangelogic.com/AssetLink/j3hbst8iry44v043331p6tt5m44ws8ng.png"
                  alt="Banner"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </div>
        </Container>

        <section className="bg-light">
  <Container className="py-5">
    <div className="text-center d-flex justify-content-center">
      <div className="col-9">
        <h1 className="fw-bold" style={{ color: "rgb(36, 53, 105)", fontSize: "50px" }}>
          Our Areas of Expertise
        </h1>
        <h5 className="mb-5">
          With expertise in Digital, Engineering and Cloud, we deliver solutions that fulfill
          the traditional, transformational and future needs of clients across the globe.
        </h5>
      </div>
    </div>

    <Row className="g-1">
      {services.map((service, index) => (
        <Col lg={3} className="p-3" key={index}>
          <a href={service.link} className="text-decoration-none text-dark">
            <div className="bg-white shadow-sm p-4 rounded-5 h-100 position-relative">
              <p className="fw-bold" style={{ color: "rgb(36, 53, 105)" }}>
                {service.title}
              </p>
              <p className="mb-5">{service.description}</p>
              <div
                className="rounded-5 d-flex justify-content-center align-items-center position-absolute"
                style={{
                  backgroundColor: "rgb(36, 53, 105)",
                  bottom: "16px",
                  right: "16px",
                  width: "40px",
                  height: "40px",
                }}
              >
                <i className="fa-solid fa-arrow-right text-white fw-bold"></i>
              </div>
            </div>
          </a>
        </Col>
      ))}
    </Row>
  </Container>
</section>


        <section
          className="py-5"
          style={{ backgroundColor: "rgb(11, 22, 63)" }}
        >
          <Container className="py-5">
            <div className="text-center text-white">
              {/* <lord-icon
                src="https://cdn.lordicon.com/ogjpwrxe.json"
                trigger="hover"
                colors="primary:#ffbb0c,secondary:#ffffff"
                style={{ width: "100px", height: "100px" }}
              ></lord-icon> */}
              <img
                src=" https://wac-cdn.atlassian.com/dam/jcr:cfefbf17-8fe1-445a-90b7-220954aac6ac/purple-safe.png?cdnVersion=2776"
                alt="Banner"
                className="img-fluid col-4"
              />

              <h1 className="fw-bold">Software That Powers Modern Business</h1>
              <p style={{ lineHeight: "28px", letterSpacing: "-0.1px" }}>
                Across industries, software is the alchemy that powers modern
                business. Leading in software is more than skillset—it's a
                cultural shift. It's building sustainable systems of delivery.
                It’s smart usage of technology, ecosystems and platforms to gain
                insights, respond with agility and deliver impact. We engineer
                products that produce outcomes for your business.
              </p>
            </div>
          </Container>
        </section>
      </>
      <Footer />
    </div>
  );
};

export default HomePage;
